import $ from 'jquery'

$(document).ready(function() {
  co_vc_sortiment()
})

function co_vc_sortiment() {
  $('.co_vc_sortiment').each(function() {})
}
